module.exports = __webpack_public_path__ + "static/img/img_0716.e52a64b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0716.jpg
// module id = pfrM
// module chunks = 0